import {
  banAccount,
  completeCardVerification,
  createAppAttestChallenge,
  createCardVerification,
  createSignInCheck,
  createStepUp,
  getAccount,
  unbanAccount,
} from "./endpoints";

export { service } from "./endpoints";
export {
  AccountBan,
  AccountRiskParams,
  AccountRiskResponse,
  AccountStanding,
  AccountTier,
  AppAttestChallengeResponse,
  BanAccountBody,
  BOT_CHECK_RECAPTCHA_ACTION,
  CARD_VERIFICATION_RETURN_PARAM,
  CardVerificationId,
  CardVerificationOutcome,
  CardVerificationResponse,
  CreateCardVerificationBody,
  CreateSignInCheckBody,
  CreateStepUpBody,
  RiskFactKind,
  RiskFactRecord,
  StandingSignal,
} from "./schemas";

export const contract = {
  signInChecks: { create: createSignInCheck },
  appAttestChallenges: { create: createAppAttestChallenge },
  stepUps: { create: createStepUp },
  cardVerifications: { create: createCardVerification, complete: completeCardVerification },
  accounts: { get: getAccount, ban: banAccount, unban: unbanAccount },
} as const;
